import type { SliderProps } from '@mui/material';
import { Slider } from '@mui/material';
import type { FormikProps } from 'formik';

type Props<ID, T> = SliderProps & { id: ID; formik: FormikProps<T> };

export function FormikSlider<
  ID extends string,
  T extends { [key in ID]?: number },
>(props: Props<ID, T>): JSX.Element {
  const { formik, ...sliderProps } = props;
  return (
    <Slider
      {...sliderProps}
      disabled={formik.isSubmitting || props.disabled}
      name={props.name ?? props.id}
      onBlur={formik.handleBlur}
      onChange={formik.handleChange}
      value={formik.values[props.id]}
      // error={formik.touched[props.id] && Boolean(formik.errors[props.id])}
      // helperText={formik.errors[props.id] || props.helperText}
    />
  );
}
